/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ConnectBYOAppsRequest {
  /**
  * Customer\'s Azure tenant ID where apps are registered
  */
  'customerTenantId': string;
  /**
  * Application ID of the Data Access App (on customer tenant)
  */
  'dataAccessAppId': string;
  /**
  * Service Principal ID of Data Access App on customer tenant
  */
  'dataAccessServicePrincipalId': string;
  /**
  * Key Vault secret URL containing Data Access App\'s client secret. This is the versionless URL from the customer\'s Key Vault. 
  */
  'dataAccessAppSecretUrl': string;
  /**
  * Application ID of the Management App (on customer tenant)
  */
  'managementAppId': string;
  /**
  * Service Principal ID of Management App on customer tenant
  */
  'managementServicePrincipalId': string;
  /**
  * Key Vault secret URL containing Management App\'s client secret. This is the versionless URL from the customer\'s Key Vault. 
  */
  'managementAppSecretUrl': string;
  /**
  * Resource ID of the Managed Identity on EON\'s tenant that is configured as federated credential for the KV Access App. This MI is assigned to scanning VMs to access the customer\'s Key Vault. 
  */
  'kvAccessAppMiResourceId': string;
  /**
  * Optional. Resource ID of the MI on customer tenant for restore operations. Used for federated credential auth when restore VM is on customer tenant. 
  */
  'dataAccessFederatedMiResourceId'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "customerTenantId",
      "baseName": "customerTenantId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "dataAccessAppId",
      "baseName": "dataAccessAppId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "dataAccessServicePrincipalId",
      "baseName": "dataAccessServicePrincipalId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "dataAccessAppSecretUrl",
      "baseName": "dataAccessAppSecretUrl",
      "type": "string",
      "format": ""
    },
    {
      "name": "managementAppId",
      "baseName": "managementAppId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "managementServicePrincipalId",
      "baseName": "managementServicePrincipalId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "managementAppSecretUrl",
      "baseName": "managementAppSecretUrl",
      "type": "string",
      "format": ""
    },
    {
      "name": "kvAccessAppMiResourceId",
      "baseName": "kvAccessAppMiResourceId",
      "type": "string",
      "format": ""
    },
    {
      "name": "dataAccessFederatedMiResourceId",
      "baseName": "dataAccessFederatedMiResourceId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ConnectBYOAppsRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

